'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultProps = exports.propTypes = exports.DIRECTIONS = undefined;

var _react = require('react');

var DIRECTIONS = exports.DIRECTIONS = {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal'
};

var propTypes = exports.propTypes = {
    id: _react.PropTypes.string.isRequired,
    type: _react.PropTypes.string,
    name: _react.PropTypes.string,
    isSelected: _react.PropTypes.bool,

    // PROPERTIES
    padding: _react.PropTypes.string,
    margin: _react.PropTypes.string,
    direction: _react.PropTypes.oneOf([DIRECTIONS.VERTICAL, DIRECTIONS.HORIZONTAL]),

    childComponents: _react.PropTypes.array,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    selectComponent: _react.PropTypes.func
};

var defaultProps = exports.defaultProps = {
    padding: '10px',
    margin: '0px',
    direction: DIRECTIONS.VERTICAL
};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/ContainerNoProps/props.js
// module id = 340
// module chunks = 0